export default [
  {
    path: '/login',
    name: 'Login',
    redirect: to => ({ name: 'Home', query: { ...to.query, auth: 'login' } }),
    meta: { 
      title: '登录',
      guest: true
    }
  },
  {
    path: '/register',
    name: 'Register',
    redirect: to => ({ name: 'Home', query: { ...to.query, auth: 'register' } }),
    meta: { 
      title: '注册',
      guest: true
    }
  }
]
